import React from 'react';
import PropTypes from 'prop-types';
import EventModal from 'shared/components/EventModal';
import Container from 'shared/components/Container';
import ModalContent from './EditOrganizationContent';

const EditOrganizationModal = props => {
  const { onCancel, visible, organizationId } = props;

  return (
    <EventModal
      visible={visible}
      onCancel={onCancel}
      renderHeader={() => (<span>Edit Organization</span>)}
    >
      <Container>
        <h1>Edit Organization</h1>

      </Container>
      <ModalContent 
        organizationId={organizationId}
        closeModal={onCancel}
      />
    </EventModal>
  );
};

EditOrganizationModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  organizationId: PropTypes.string
};

EditOrganizationModal.defaultProps = {
  organizationId: null
}

export default EditOrganizationModal;